<template>
    <div class="card">
        <div class="body">
            <form ref="formPassword" @submit="change">
                <ValidationObserver ref="observerForm">
                    <p>{{ $t('passwordPageInfo') }}</p>
                    <div class="row">
                        <div class="col-md-6">
                            <ValidationProvider :rules="rules.actual" name="vpActual" v-slot="{ errors, valid, validated }">
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <label>{{ $t('current_password') }}:</label>
                                    <div class="input-container" :class="{'valid': valid && validated}">
                                        <input name="pswActual" v-model="password.actual" :type="type.current" maxlength="20" class="form-control" tabindex="1">
                                        <a href="#" class="show-pass border-0 bg-transparent" @click.prevent="showPassword('current')">
                                            <svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false">
                                                <path opacity=".3" d="M12 6a9.77 9.77 0 00-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5A9.77 9.77 0 0012 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"></path>
                                                <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13a9.77 9.77 0 01-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5A9.77 9.77 0 0112 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
                                                <line v-show="type.current == 'text'" x1="3" y1="3" x2="21" y2="21" />
                                            </svg>
                                        </a>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider :rules="rules.newp" name="vpNew" v-slot="{ valid, validated }" vid="vidnewp">
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <label>{{ $t('new_password') }}:</label>
                                    <div>
                                        <mmPassword :configPatron="configPatron" v-model="password.newp" nombre="newpassword"></mmPassword>
                                    </div>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider :rules="rules.repeat" name="vpRepeat" v-slot="{ errors, valid, validated }">
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <label>{{ $t('confirm_password') }}:</label>
                                    <div :class="{'valid': valid && validated}">
                                        <input name="pswNueva2" :type="type.new" v-model="password.repeat" maxlength="20" :placeholder="$t('insert_new_password')" class="form-control" tabindex="3">
                                        <a href="#" class="show-pass border-0 bg-transparent" @click.prevent="showPassword('new')">
                                            <svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false">
                                                <path opacity=".3" d="M12 6a9.77 9.77 0 00-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5A9.77 9.77 0 0012 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"></path>
                                                <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13a9.77 9.77 0 01-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5A9.77 9.77 0 0112 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
                                                <line v-show="type.new == 'text'" x1="3" y1="3" x2="21" y2="21" />
                                            </svg>
                                        </a>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider :rules="rules.question" name="vpQuestion" v-slot="{ errors, valid, validated }" v-if="this.$Params.recover=='1' || this.$Params.recover=='3'">
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <label>{{ $t('preguntaSeguridad') }}:</label>
                                    <div :class="{'valid': valid}">
                                        <textarea class="form-control" v-model="password.question" tabindex="4"></textarea>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider :rules="rules.question" name="vpResponse" v-slot="{ errors, valid, validated }" v-if="this.$Params.recover=='1' || this.$Params.recover=='3'">
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <label>{{ $t('respuestaPregunta') }}:</label>
                                    <div :class="{'valid': valid}">
                                        <input type="text" class="form-control" v-model="password.response" tabindex="5">
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </ValidationObserver>
            </form>
        </div>
        <div class="footer">
            <a href="#" @click.prevent="change" class="btn btn-primary waves-effect waves-light btn-submit-success validate-tab validate-loading">{{ $t('change') }}</a>
        </div>
        <ModalAuthenticator ref="authenticator" @getCode="getCodeAuthenticator" />
    </div>
</template>

<script>
    import ModalAuthenticator from '@/components/ModalAuthenticator.vue'
    import { userService } from '../api/user';
    import mmPassword from '@/components/common/mmPassword.vue';
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    import { rules } from "@/_helpers/validations/validate-password";
    import Cookies from 'js-cookie';
    export default {
        name: 'Password',
        data() {
            return {
                rules,
                password: {
                    actual: '',
                    newp: '',
                    repeat: '',
                    question: '',
                    response: '',
                    code: ''
                },
                configPatron: {},
                type: {
                    current: 'password',
                    new: 'password'
                }
            }
        },
        components: {
            ModalAuthenticator,
			mmPassword,
            ValidationObserver,
            ValidationProvider
        },
        methods: {
            showPassword(type) {
				this.type[type] = this.type[type] === 'password' ? 'text' : 'password';
			},
            async change() {
                if(await this.$refs.observerForm.validate()) {
                    if(this.$Params.mfa_datos && this.$Params.user_authenticator==1 && !this.$Params.need_change_password)
                        this.$refs.authenticator.openModal();
                    else
                        this.changeData();
                }
            },
            async changeData()
            {
                if(await userService.changePassword(this.password)) {
                    this.password.actual = '';
                    this.password.newp = '';
                    this.password.repeat = '';
                    this.$refs.observerForm.reset();
                    this.$Params.need_change_password = '0';
                    Cookies.set("needChangePassword", false);
                }   
            },
            getCodeAuthenticator(data) 
            {
                this.password.code = data.code;
                this.changeData();
            },
        },
        async created() {
            let patron = await userService.getPasswordPattern();
            this.configPatron = patron;
        }
    }
</script>

<style>
.show-pass {
		position: absolute;
		right: 3px;
		top: 6px;
		opacity: .7;
		z-index: 10;
	}
.show-pass {
		right: 18px;
	}
.show-pass:hover {
		opacity: 1;
	}
.show-pass path { fill:#97a6ba; }
.show-pass line { stroke:#97a6ba; stroke-width: 3px; }
</style>